import { useEffect, useState } from 'react';

export interface ExamEvent {
  id: string;
  title: string;
  date: string;
  time?: string;
  location?: string;
  program: string;
}

export function useExams() {
  const [exams, setExams] = useState<ExamEvent[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadExams = async () => {
      try {
        const response = await fetch('/academic_calendar.json');
        const data = await response.json();
        const examEvents: ExamEvent[] = [];
        const calendar = data.academic_calendar;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (calendar) {
          Object.entries(calendar).forEach(([semesterKey, semesterData]: [string, any]) => {
            const semesterName = semesterKey.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
            if (semesterData.events) {
              semesterData.events.forEach((event: any, index: number) => {
                if (event.event && event.event.toLowerCase().includes('exam')) {
                  const examDate = event.date || '';
                  try {
                    const dateMatch = examDate.match(/(\w+)\s+(\d+),?\s+(\d{4})/);
                    if (dateMatch) {
                      const [, month, day, year] = dateMatch;
                      const examDateObj = new Date(`${month} ${day}, ${year}`);
                      if (examDateObj >= today) {
                        examEvents.push({ id: `${semesterKey}-${index}`, title: event.event, date: examDate, program: semesterName });
                      }
                    } else {
                      examEvents.push({ id: `${semesterKey}-${index}`, title: event.event, date: examDate, program: semesterName });
                    }
                  } catch {
                    examEvents.push({ id: `${semesterKey}-${index}`, title: event.event, date: examDate, program: semesterName });
                  }
                }
              });
            }
          });
        }
        setExams(examEvents);
      } catch (error) {
        setExams([]);
      } finally {
        setIsLoading(false);
      }
    };
    loadExams();
  }, []);

  return { exams, isLoading };
}
